module["exports"] = [
  "(Persero) Tbk",
  "Tbk"
];